import { TypeObjCPV } from './TypeObjCPV';
import { TypeNatureMarcheDivers } from './TypeNatureMarcheDivers';
export class TypeDescMarche {

  public cpv: TypeObjCPV;
 
  public natureMarche: TypeNatureMarcheDivers;

  constructor() {
    this.natureMarche = new TypeNatureMarcheDivers();
    this.cpv = new TypeObjCPV();
  }
}
